import styled, { css } from 'styled-components';

export const AnimationContainer = styled.div(
  ({ theme }) => css`
    width: ${theme.sz.s14};
    height: ${theme.sz.s14};
    margin: 0 -6px 0 -${theme.sz.s2};
  `,
);

export const ButtonContainer = styled.div<{ $isHighlighted: boolean }>(
  ({ theme, $isHighlighted }) => css`
    background: ${$isHighlighted && theme.co.primary70};
    width: ${theme.sz.s10};
    height: ${theme.sz.s10};
    margin: ${theme.sz.s2} ${theme.sz.s05} ${theme.sz.s2} ${theme.sz.s05};
    border-radius: ${theme.bo.round};

    align-content: center;
    text-align: center;
  `,
);
